export function fmtDate(value?: string | null) {
  if (!value) return '—';
  return new Date(value).toLocaleString('ru-RU');
}

export function osLabel(item: { os?: string | null; osVersion?: string | null }) {
  return [item.os, item.osVersion].filter(Boolean).join(' ') || '—';
}

export function modelConfidenceMark(confidence?: string | null) {
  if (confidence === 'approximate') return ' ≈';
  if (confidence === 'likely') return ' *';
  return '';
}
